import script from "./HolidayPayObligationsTableExport.vue?vue&type=script&setup=true&lang=ts"
export * from "./HolidayPayObligationsTableExport.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__